export const URL_PATTERN = '^/.*$|^https://([A-Za-z0-9-]+\\.)+[A-Za-z0-9-]+($|\\/.*$)';

export enum AppSku {
    WEB = 'web',
    ANDROID_WEB = 'android_web',
    IOS_WEB = 'ios_web'
}
